import { useSelector } from 'react-redux';
import { BottomNavigation, BottomNavigationAction } from '@mui/material';
import { PeoplesIcon, TicketIcon, RupeesIcon } from '../../icons/MaterialIcon';
import { H4 } from '../../themes/typography';

export default function TicketNavigationTabs() {
    const tabsStyles = {
        width: '466px',
        minWidth: '466px',
        height: '86px',
        borderRadius: '1rem',
        display: 'flex',
        justifyContent: 'space-around',
        alignItems: 'center',
        gap: '0px',
        padding: '0px',
        cursor: 'context-menu'
    };

    const iconStyles = {
        color: 'var(--quaternary-color)',
        fontSize: '3rem'
    };

    const activeStep = useSelector((state) => state.ticketBuying.activeStep);

    return (
        <BottomNavigation
            sx={{
                alignSelf: 'stretch',
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
                backgroundColor: 'transparent',
                '& .Mui-selected': {
                    background: 'var(--gradient-blue)'
                },
                '& .MuiBottomNavigationAction-label': {
                    background: 'transparent'
                }
            }}
            value={activeStep}
            showLabels
        >
            <BottomNavigationAction
                sx={tabsStyles}
                disableTouchRipple
                label={<H4 color="var(--tertiary-color)">Ticket</H4>}
                value="tickets"
                icon={<TicketIcon sx={iconStyles} />}
            />
            <BottomNavigationAction
                sx={tabsStyles}
                disableTouchRipple
                label={<H4 color="var(--tertiary-color)">Attendee Info</H4>}
                value="attendee"
                icon={<PeoplesIcon sx={iconStyles} />}
            />
            <BottomNavigationAction
                sx={tabsStyles}
                disableTouchRipple
                label={<H4 color="var(--tertiary-color)">Payment</H4>}
                value="payment"
                icon={<RupeesIcon sx={iconStyles} />}
            />
        </BottomNavigation>
    );
}